import * as Sentry from '@sentry/nuxt';
import { onBeforeSend } from '@utils/sentryHelpers';

const config = useRuntimeConfig();

const { sentryHost, sentryRelease, sentryEnv } = config.public;

if (sentryHost) {
    Sentry.init({
        environment: sentryEnv,
        dsn: sentryHost,
        // Default to package.json's version
        // Commit hash on staging instance
        release: sentryRelease,
        tracesSampleRate: 0.2,
        beforeSend(event) {
            return onBeforeSend(event);
        },
    });
}
